import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export interface UpdateChainStepPayload {
  abstractUuid: string;
  title: string;
  priority?: 'low' | 'medium' | 'high';
  serviceAccount?: string;
}

export function useUpdateChainStep() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async (payload: UpdateChainStepPayload) => {
      const res = await fetch(
        `${
          import.meta.env.VITE_API_URL
        }/bundles/graph_bundle/functions/update_chain_step`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: payload ? JSON.stringify(payload) : '',
        }
      );

      return res.json();
    },
  });
}
